import React from 'react';
import {Text, Button} from '@wix/wix-ui-tpa/cssVars';
import {Replace} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './ErrorState.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';

export enum ErrorStateDataHooks {
  Root = 'ErrorStateDataHooks.Root',
  Title = 'ErrorStateDataHooks.Title',
  Subtitle = 'ErrorStateDataHooks.Subtitle',
  Button = 'ErrorStateDataHooks.Button',
}

interface ErrorStateProps {
  title?: string;
  subtitle?: string;
  ctaButton?: React.ReactElement | null;
  onClick?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = (props: ErrorStateProps) => {
  const {title, subtitle, ctaButton, onClick: onClickProp} = props;
  const localeKeys = useLocaleKeys().checkout.couldntLoadError;

  const onClick = () => {
    onClickProp?.();
    window.location.reload();
  };

  return (
    <div data-hook={ErrorStateDataHooks.Root} className={classes.root}>
      <Text data-hook={ErrorStateDataHooks.Title} className={classes.title}>
        {title ?? localeKeys.title()}
      </Text>
      <Text data-hook={ErrorStateDataHooks.Subtitle} className={classes.subtitle}>
        {subtitle ?? localeKeys.subtitle()}
      </Text>

      {ctaButton ?? (
        <Button
          data-hook={ErrorStateDataHooks.Button}
          className={classes.button}
          prefixIcon={<Replace />}
          onClick={onClick}>
          {localeKeys.cta()}
        </Button>
      )}
    </div>
  );
};
